import * as type from "../types";

export function openModal(modalMessage) {
    return {
        type: type.OPEN_MODAL,
        payload: modalMessage,
    };
}

export function closeModal() {
    return {
        type: type.CLOSE_MODAL,
        payload: "",
    };
}
